import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2, Route } from "lucide-react";
import { toast } from "sonner";
import Header from "@/components/Header";
import { useLang } from "@/i18n";
import { api, formatApiError, loadRazorpay } from "@/lib/api";

export default function Travel() {
  const { token } = useParams();
  const { t } = useLang();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  const [paying, setPaying] = useState(false);

  useEffect(() => {
    api.get(`/travel/${token}`).then((r) => setD(r.data)).catch(() => setErr(true));
  }, [token]);

  const pay = async () => {
    setPaying(true);
    try {
      const { data } = await api.post(`/travel/${token}/order`);
      if (!(await loadRazorpay()) || !window.Razorpay) { toast.error("Could not load Razorpay"); setPaying(false); return; }
      const rzp = new window.Razorpay({
        key: process.env.REACT_APP_RAZORPAY_KEY_ID || data.key_id, amount: data.amount, currency: data.currency, order_id: data.order_id,
        name: "CHELA", description: "Travel charge", prefill: { contact: d.phone }, theme: { color: "#E05624" },
        modal: { ondismiss: () => setPaying(false) },
        handler: async (resp) => {
          try { await api.post(`/travel/${token}/verify`, resp); setD((x) => ({ ...x, paid: true })); }
          catch (e2) { toast.error(formatApiError(e2.response?.data?.detail) || "Verification failed"); } finally { setPaying(false); }
        },
      });
      rzp.open();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Could not start payment"); setPaying(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <Header />
      <div className="chela-container max-w-lg py-10">
        {err && <p data-testid="travel-bad" className="text-center text-[#5A5D65]">{t("tr_bad")}</p>}
        {d && (
          <div data-testid="travel-card" className="chela-card rounded-3xl p-6" style={{ transform: "none" }}>
            <h1 className="font-display font-extrabold text-2xl text-[#121316] flex items-center gap-2"><Route className="text-[#E05624]" /> {t("tr_title")}</h1>
            <p className="mt-2 text-[#5A5D65]">{d.name} · {d.service} · #{d.ref}</p>
            <div className="mt-5 rounded-2xl bg-[#FFF1EC] p-4 flex justify-between items-center">
              <span className="text-[#3A3D45]">{d.km} km × ₹{d.rate}</span>
              <span data-testid="travel-amount" className="font-display font-extrabold text-3xl text-[#E05624]">₹{d.amount}</span>
            </div>
            <p className="mt-3 text-sm text-[#5A5D65]">{t("tr_note")}</p>
            {d.paid
              ? <div data-testid="travel-paid" className="mt-5 rounded-2xl bg-[#E8F7EE] text-[#1B8A4B] font-bold p-4 flex gap-2 justify-center"><CheckCircle2 size={20} /> {t("tr_paid")}</div>
              : <button data-testid="travel-pay" onClick={pay} disabled={paying} className="mt-5 w-full h-14 rounded-full btn-saffron font-bold disabled:opacity-60">{paying ? t("pay_opening") : `${t("pay_now")} ₹${d.amount}`}</button>}
          </div>
        )}
      </div>
    </div>
  );
}
